import FBody from '@/plugins/form/FBody';
import FPrice from '@/plugins/form/FPrice';
import FInput from '@/plugins/form/FInput';

const dateYesterday = new Date();
dateYesterday.setDate(dateYesterday.getDate() - 1);

export default class extends FBody {
  priceFrom = new FPrice({
    label: 'Цена от',
  });

  priceTo = new FPrice({
    label: 'до',
  });

  name = new FInput({
    label: 'Название',
  });

  constructor(props) {
    super(props);
    this.setItems([
      ['priceFrom', this.priceFrom],
      ['priceTo', this.priceTo],
      ['name', this.name],
    ]);
  }
}
